import _styled from "styled-components";
import cn from 'classnames';
import { css } from 'styled-components';
import ArrowLeft from '@crehana/icons/outline/ArrowLeft';
import { InverseButton, KEY_NAMES } from '@crehana/ui';
import { useHlsContext } from "../context/Hls";
import { usePlaybackContext } from "../context/Playback";
import { useResponsiveContext } from "../context/Responsive";
import { useUIContext } from "../context/UI";
import { useTranslation } from "../hooks";
import { ControlButton, SettingsButton } from "./ui";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var TopControls = function TopControls(_ref) {
  var _header$back, _header$back2;
  var isIOS = _ref.isIOS;
  var _useResponsiveContext = useResponsiveContext(),
    playerSize = _useResponsiveContext.playerSize;
  var _usePlaybackContext = usePlaybackContext(),
    togglePlay = _usePlaybackContext.togglePlay;
  var _useHlsContext = useHlsContext(),
    currentQualityLabel = _useHlsContext.currentQualityLabel,
    hasLowQuality = _useHlsContext.hasLowQuality;
  var _useUIContext = useUIContext(),
    header = _useUIContext.header,
    onBackClick = _useUIContext.onBackClick,
    changeActiveMenu = _useUIContext.changeActiveMenu,
    hideSpeedOptions = _useUIContext.hideSpeedOptions,
    visibleUi = _useUIContext.visibleUi;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var hasSettings = currentQualityLabel || !hideSpeedOptions;
  var openSettings = function openSettings(e) {
    e.stopPropagation();
    changeActiveMenu('settings');
  };
  var onKeyDown = function onKeyDown(event) {
    if (event.key === KEY_NAMES.SPACE) {
      event.stopPropagation();
      togglePlay();
    }
  };
  var paddingCss = /*#__PURE__*/css(["\n    padding: 12px 8px 0 8px;\n  "]);
  if (playerSize.matches.xs) {
    paddingCss = css(["\n      padding: 24px 16px 0 16px;\n    "]);
  }
  if (playerSize.matches.sm) {
    paddingCss = css(["\n      padding: 24px 20px 0 20px;\n    "]);
  }
  if (playerSize.matches.md) {
    paddingCss = css(["\n      padding: 48px 40px 0 40px;\n    "]);
  }
  return /*#__PURE__*/_jsxs(_StyledDiv, {
    className: cn('cp-top-controls absolute w-full flex items-start top-0 right-0 left-0', header ? 'justify-between' : 'justify-end', visibleUi ? 'cursor-pointer opacity-1 z-5' : 'cursor-none opacity-0 z-3'),
    onClick: togglePlay,
    onKeyDown: onKeyDown,
    $_css: paddingCss,
    children: [header && /*#__PURE__*/_jsxs("div", {
      className: cn('flex items-start', playerSize.matches.md ? 'flex-col w-full' : 'flex-row'),
      children: [((_header$back = header.back) === null || _header$back === void 0 ? void 0 : _header$back.onClick) && !playerSize.matches.md && /*#__PURE__*/_jsx(ControlButton, {
        className: cn({
          'mr-16': !!header.title
        }),
        icon: {
          component: ArrowLeft
        },
        onClick: onBackClick,
        "aria-label": header.back.label || t('BACK_LABEL'),
        isSm: playerSize.value === 'sm'
      }), header.title && playerSize.matches.xs && /*#__PURE__*/_jsx("p", {
        className: "text-white font-h4",
        children: header.title
      }), header.subtitle && playerSize.matches.md && /*#__PURE__*/_jsx("p", {
        className: cn('font-subtitle2 text-white', {
          'mt-4': !!header.title
        }),
        children: header.subtitle
      }), ((_header$back2 = header.back) === null || _header$back2 === void 0 ? void 0 : _header$back2.onClick) && playerSize.matches.md && /*#__PURE__*/_jsx(InverseButton, {
        className: cn({
          'mt-24': !!(header.title || header.subtitle)
        }),
        label: header.back.label || t('BACK_LABEL'),
        leftIcon: {
          component: ArrowLeft
        },
        onClick: onBackClick,
        isWhite: true,
        isDark: true,
        size: "s",
        "data-tour": "backToDashboardBtn"
      })]
    }), !isIOS && !playerSize.matches.sm && hasSettings && /*#__PURE__*/_jsx(SettingsButton, {
      className: "ml-8",
      onClick: openSettings,
      currentQuality: currentQualityLabel,
      hasLowQuality: hasLowQuality
    })]
  });
};
export default TopControls;
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  componentId: "sc-1dm0j6y-0"
})(["\n        ", "\n        transition: ", ";\n        & span {\n          user-select: none;\n        }\n      "], function (p) {
  return p.$_css;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.transition('opacity', 300);
});